
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuSyudanSyudanImage } from "@src/constants/images";
import { meta as ryunokoPageMeta } from "./ryunoko.mdx";
import { meta as noodleStandTokyoPageMeta } from "./noodle_stand_tokyo.mdx";
import { meta as minoringoPageMeta } from "./minoringo.mdx";
import { meta as afuriPageMeta } from "./afuri.mdx";
export const meta = {
  path: "/media/harajuku/syudan",
  title: "【名店の味を！】大人数でも大丈夫な原宿ランチ３選！",
  description: "原宿で大人数でランチをしたいときは、席数の問題で名店の味を諦めないといけないという方も多いのではないでしょうか。原宿で席数が豊富にあり、食べログの評価が高い名店のランチが食べられるお店を３つに厳選してご紹介します。それぞれの店舗の席数や人気のメニューも併せてご紹介しております。",
  topImg: harajukuSyudanSyudanImage,
  author: murakamiMasanori,
  tags: ["大人数", "原宿", "人気店", "まとめ記事", "食べログ高評価"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿で大人数でランチをしたいときは、席数の問題で名店の味を諦めないといけないという方も多いのではないでしょうか。`}</p>
    <p>{`なかなか大人数で入れるお店を見つけられない、見つけても並んでいて入れないといった悩みを抱えたことはありませんでしょうか？`}</p>
    <p>{`今回は、テラス席も完備しているようなお店から、まるで外国にいるかのような広々とした店内のお店まで、大人数でも安心できる原宿のお店をご紹介します。`}</p>
    <h2>{`bills 東急プラザ表参道原宿`}</h2>
    <InstaImage postId="B-CeBPwDONN" mdxType="InstaImage" />
    <p>{`世界一の朝食と呼び声高い bills は、オーストラリアシドニー発祥のお店で、ハリウッドセレブをはじめとして多くの有名人が訪れる世界的にも人気のお店です。原宿と表参道の間に位置するお店で、モーニングやランチ問わずに、どちらも多くの行列ができることでも知られています。`}</p>
    <h3>{`122 席完備で大人数でも安心`}</h3>
    <InstaImage postId="B-dqZL3Bq4y" mdxType="InstaImage" />
    <p>{`Bills 原宿の店舗は、広々とした店内の設計になっていて、なんとその席数は 122 席を完備する原宿エリアでも最大級のお店。
大人数でも待ち時間なしで安心して入れることが多いで、家族連れの方も多く来店されます。`}</p>
    <InstaImage postId="B99NmMcAHbJ" mdxType="InstaImage" />
    <p>{`テラス席も完備しているので、席が空いているタイミングだと、大人数でもテラスでランチができるのが、bills の魅力の一つだと思います。
テラス席でのランチを、大人数でもその日の気分に合わせて選んでみるのはいかがでしょうか。`}</p>
    <h3>{`大人数でも楽しめるランチメニュー`}</h3>
    <p>{`Bills では、人気のリコッタパンケーキなどがついた７名様まで利用できるシェアメニュメニューがあり、大人数には嬉しいメニューがあります。
定番の人気メニューを大人数でシェアしながら食べるのは楽しそうですよね！`}</p>
    <InstaImage postId="CAG6ztql6pk" mdxType="InstaImage" />
    <InstaImage postId="B9LtYKMp4cN" mdxType="InstaImage" />
    <p>{`詳細は食べログのページからご確認ください！`}</p>
    <p><a parentName="p" {...{
        "href": "https://tabelog.com/tokyo/A1306/A130601/13139698/party/99467768"
      }}>{`https://tabelog.com/tokyo/A1306/A130601/13139698/party/99467768`}</a></p>
    <h4>{`その他`}</h4>
    <p>{`パンケーキの他にもサンドイッチやサラダなど、豊富なランチメニューを取り揃えています。その日の気分に合わせて、ランチを選んでみるのはいかがでしょうか？`}</p>
    <p>{`サーモンとビーツのオープンサンドイッチ`}</p>
    <InstaImage postId="CBU_NXRJ71E" mdxType="InstaImage" />
    <p>{`サーモンとズッキーニのサラダ`}</p>
    <InstaImage postId="CBM-FFCFBMx" mdxType="InstaImage" />
    <ShopInfoBox shopId="brmklui23akg009e18vg" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`ピッツェリア カンテラ`}</h2>
    <InstaImage postId="CAjayRwgZvd" mdxType="InstaImage" />
    <p>{`原宿駅から徒歩 7 分、明治神宮駅から徒歩 2 分の好アクセスの立地にあるのが、原宿のピザで有名なピッツェリア カンテラ。
3 年連続百名店に選出されており、食べログの評価は 3.7 を超える好評価で、原宿だけにとどまらず、都内でも有名なお店。`}</p>
    <p>{`スタイリッシュな内装やたくさんのテラス席を構えているので、大人数でのランチはもちろんのこと、デートや女子会などさまざまなニーズでも使用されるお店です。`}</p>
    <h3>{`100 席完備で大人数でも安心`}</h3>
    <InstaImage postId="B_1FYg9Abrq" mdxType="InstaImage" />
    <p>{`ピッツェリア カンテラでは席数はなんと 100 席を完備しており、大人数でのランチも対応することができます。
先ほどの bills と同様で、原宿エリアでは最大級のお店になっています。
原宿の景色を眺めることができるテラス席があるので、天気が晴れた日には、爽快な空気の中、大人数で食べるランチはきっと盛り上がること間違いなし！`}</p>
    <h3>{`全粒粉で作る釜焼きピザ`}</h3>
    <InstaImage postId="Bq3_P89AT3H" mdxType="InstaImage" />
    <InstaImage postId="CAB52l7gO07" mdxType="InstaImage" />
    <p>{`カンテラのピザは全粒粉を使用して作るそうで、見た目は一般的なピザよりもやや茶色ががった色をしています。全粒粉はこだわりの銘柄を使用しており、健康にも優しいヘルシーな成分でできているので、少しでも体に気を使いたい方でも安心して食べられるのが特徴的。`}</p>
    <p>{`また、本格的な窯でピザを焼くので、釜焼きだからこそ広がる風味も同時に楽しむことができるのが特徴です。`}</p>
    <h3>{`豊富なランチプラン`}</h3>
    <InstaImage postId="B6vU_PLpipS" mdxType="InstaImage" />
    <p>{`最大 50 名の人数でも利用できるプランがあり、その他にも様々なパーティープランが用意されています。
ピザだけではなく、パスタや飲み放題がついたメニューも準備しているので、大人数で原宿ランチをするときは、ピッツェリア カンテラを選択肢の候補として入れていただければと思います！`}</p>
    <ShopInfoBox shopId="brjat6223akg00cd2nu0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`ナプレ南青山本店`}</h2>
    <InstaImage postId="CAdFjkdprGA" mdxType="InstaImage" />
    <p>{`本場イタリアのピザの味に近いとされている名店で、ナポリピザを日本に広めて開拓者的な存在がナプレ。`}</p>
    <p>{`ピザ職人のピザ・イオーロが作ってくれるピザが人気で、食べログの評価は 3.7 を超え、百名店に選出されている実力派のお店。`}</p>
    <p>{`東京でも複数店舗を構えており、ランチの時間帯は行列ができることがよくあるほど。`}</p>
    <h3>{`88 席完備で大人数でも安心`}</h3>
    <InstaImage postId="CBxSBmiBooI" mdxType="InstaImage" />
    <p>{`ナプレの外観・内観は、ヨーロッパ風のお城のような建物になっています。店内はまるで南イタリアにいるかのような、透き通った白を基調とした明るい店内になっています。`}</p>
    <p>{`テーブルクロスがたくさんかかったテーブルの一つ一つが、上品さを感じさせるようなデザイン。`}</p>
    <p>{`席数も 88 席を完備しており、bills やカンテラと同様に原宿エリア最大級のお店です。`}</p>
    <p>{`待ち時間なしで入ることができたり、大人数でランチをするのに問題のない席数になっているのが安心！`}</p>
    <h3>{`名工の窯と現地の食材で作るピザ`}</h3>
    <InstaImage postId="CBo5whXAkFJ" mdxType="InstaImage" />
    <p>{`イタリアの名工が親子で作った特注のピザ窯でピザが作られます。
その上、現地イタリアから取り寄せた食材を使ってピザを作るそうで、ピザ職人が現地の味を最大限に引き出すピザは、現地のイタリア人も「故郷の味を思い出す」というほど、本場に近い味を再現しているそうです。`}</p>
    <p>{`だからこそそのピザを求めてたくさんの方が原宿に訪れ、行列を作っているのですね！`}</p>
    <ShopInfoBox shopId="bredr6223akg00abiq9g" mdxType="ShopInfoBox" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`原宿で大人数でもランチができるお店を厳選してご紹介しましたが、いかがでしたでしょうか。
世界的に有名なランチメニューが豊富な bills、大人数に嬉しいパーティープランや開放的なテラスでランチが楽しめるピッツェリア カンテラ、イタリア人も認める本物に近い味が楽しめるナプレなど、それぞれに違った楽しみ方があると思います！`}</p>
    <p>{`大人数でのランチでは、お好きなお店をチェックしてみてください！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;